import * as React from 'react'
import './layout.scss'
import {useEffect} from "react";
import {document} from "browser-monads";
import Cookie from "js-cookie";

const Layout = ({children}) => {

  useEffect(() => {
    let params = (new URL(document.location)).searchParams
    let irclickid = params.get('irclickid')
    let irpid = params.get('irpid')
    let linkParameters = window.location.search.substring(1)
    if (irclickid) {
      Cookie.set('irclickid', irclickid, {path: '/', domain: process.env.IMPACT_COOKIE_DOMAIN, expires: 30})
    }
    if (irpid) {
      Cookie.set('irpid', irpid, {path: '/', domain: process.env.IMPACT_COOKIE_DOMAIN, expires: 30})
    }
    if (linkParameters) {
      Cookie.set('linkParameters', linkParameters)
    }
  }, [])

  return (
    <div className="layout">
      <main>
        {children}
      </main>
    </div>
  )
}

export default Layout
